import React from 'react'

const Test = () => {
  return (
    <div>
      <h1>Hello WOrld</h1>
    </div>
  )
}

export default Test
